/* eslint-disable react/prop-types */
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Space,
  Upload,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { insuranceCodeValue } from '../../../models/setting'
import {
  getSystemList,
  selectInsuranceArray,
} from '../../tenant/setting/TenentSettingSlice'
import { getImportExcelAsync } from '../../tenant/tenantSlice'
import {
  getSendCatalogChangeNotifyAsync,
  getUploadProgress,
  getZjCatalogChangeImportAsync,
  getZjCatalogFullImportAsync,
  syncInsuranceListAsync,
  uploadExcelAsync,
  UploadProgressResponse,
} from '../medicalSlice'
const { Option } = Select

export interface CurrentQueryProps {
  onValueChange: (vs: any) => void
  refresh?: () => void
  showNameSearch?: boolean
  code: number // 1301西药 1302中药 1305诊疗 1306材料
}
export const CurrentQuery: React.FC<CurrentQueryProps> = ({
  onValueChange,
  refresh,
  code,
  showNameSearch = true,
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const Uploadref = useRef<any>(null)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [isIncremental, setIsIncremental] = useState(0) // 全量0 增量1

  const [showProgress, setShowProgress] = useState(false)

  const [message, setMessage] = useState('')

  const [progress, setProgress] = useState('')

  const [idsList, setIdsList] = useState<Array<number>>([])

  const [TYLoading, setTYLoading] = useState(false)

  const [BGLoading, setBGLoading] = useState(false)

  const [BGTZLoading, setBGTZLoading] = useState(false)

  const upload = (file: any, onSuccess: any) => {
    if (file instanceof File) {
      const params = {
        code,
        insuranceCode: form.getFieldValue('insuranceCode'),
        isIncremental: isIncremental,
        file,
        listType: '000'
      }
      dispatch(uploadExcelAsync(params)).then(unwrapResult).then((result: any) => {
        notification.success({
          message: '导入成功',
          duration: 3,
        })
        console.log(result);
        setIdsList([result.id])
        setShowProgress(result?.taskStatus === 0 || result?.taskStatus === 9)
        setMessage(result?.taskMsg)
        // form.submit()
      })
      onSuccess &&
        onSuccess(null, (null as unknown) as XMLHttpRequest)
    }
  }

  let timer: any = null
  useEffect(() => {
    console.log(idsList, showProgress);
    console.log(888888888888, timer);
    if (timer && !showProgress) {
      clearInterval(timer)
    }
    if (idsList) {
      if (!timer && showProgress) {
        timer = setInterval(() => {
          getProgress()
          if (!showProgress) {
            clearInterval(timer)
          }
        }, 3000)
      }
    }
    return () => {
      timer && clearInterval(timer)
    }
  }, [showProgress])

  const getProgress = () => {
    dispatch(getUploadProgress({ ids: [...idsList] })).then(unwrapResult).then((res: any) => {
      if (res.length) {
        setShowProgress(res[0]?.taskStatus === 0 || res[0]?.taskStatus === 9)
        setMessage(res[0]?.taskMsg)
        if (res[0].taskCnt !== 0 || res[0].taskSum !== 0) {
          const str = `${res[0].taskCnt} / ${res[0].taskSum} `
          setProgress(str)
        }
        if (res[0]?.taskStatus === 1) {
          notification.success({
            message: res[0]?.taskMsg
          })
        }
      } else {
        setShowProgress(false)
      }
    })
  }

  useEffect(() => {
    if (insuranceArray.length) {
      form.setFieldsValue({
        insuranceCode: insuranceArray[0].insuranceCode,
      })
    }
  }, [insuranceArray])

  useEffect(() => {
    setIsIncremental(0)
  }, [code])

  const getListType = (code: number) => {
    switch (code) {
      case 1301:
        return '101';
      case 1302:
        return '102';
      case 1305:
        return '201';
      case 1306:
        return '301';
      default:
        return '000'
    }
  }

  const getZjCatalogChangeImport = (file: any, onSuccess: any) => {
    if (file instanceof File) {
      const params = {
        insuranceCode: form.getFieldValue('insuranceCode'),
        file,
      }
      dispatch(getZjCatalogChangeImportAsync(params))
        .then(unwrapResult)
        .then((result: any) => {
          notification.success({
            message: '操作成功',
            duration: 3,
          })
          refresh && refresh()
        })
        .finally(() => {
          setTYLoading(false)
        })
      onSuccess && onSuccess(null, (null as unknown) as XMLHttpRequest)
    }
  }

  const getZjCatalogFullImport = (file: any, onSuccess: any) => {
    if (file instanceof File) {
      const params = {
        insuranceCode: form.getFieldValue('insuranceCode'),
        file,
      }
      dispatch(getZjCatalogFullImportAsync(params))
        .then(unwrapResult)
        .then((result: any) => {
          notification.success({
            message: '操作成功',
            duration: 3,
          })
          refresh && refresh()
        })
        .finally(() => {
          setBGLoading(false)
        })
      onSuccess && onSuccess(null, (null as unknown) as XMLHttpRequest)
    }
  }

  return (
    <Form
      form={form}
      autoComplete='off'
      onFinish={(vs) => {
        onValueChange(vs)
      }}
    >
      <Row
        justify='space-between'
        align='middle'
        style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
        wrap={false}
      >
        <Space>
          {/* {showNameSearch && ( */}
          <Form.Item name='name' noStyle>
            <Input
              allowClear
              placeholder={`请输入${showNameSearch ? '目录名称' : '中心编码'}`}
              prefix={<SearchOutlined />}
              style={{ width: '200px' }}
              onChange={form.submit}
            />
          </Form.Item>
          {/* )} */}

          <Form.Item name='insuranceCode' noStyle>
            <Select
              suffixIcon={<CaretDownFilled />}
              placeholder='医保险种'
              onChange={form.submit}
              style={{ width: '130px' }}
            >
              {insuranceArray.length !== 0 &&
                insuranceArray.map((v: any) => (
                  <Option key={v.insuranceCode} value={v.insuranceCode}>
                    {v.insuranceName}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Button type='primary' onClick={form.submit}>
            查询
          </Button>
        </Space>
        <Space>
          <Upload
            accept='.xls,.xlsx'
            maxCount={1}
            customRequest={({ file, onSuccess }) => {
              console.log('file', file)
              setTYLoading(true)
              getZjCatalogChangeImport(file, onSuccess)
            }}
            showUploadList={false}
          >
            <Button type='primary' loading={TYLoading}>
              目录停用导入
            </Button>
          </Upload>
          <Upload
            accept='.xls,.xlsx'
            maxCount={1}
            customRequest={({ file, onSuccess }) => {
              console.log('file', file)
              setBGLoading(true)
              getZjCatalogFullImport(file, onSuccess)
            }}
            showUploadList={false}
          >
            <Button type='primary' loading={BGLoading}>
              目录变更导入
            </Button>
          </Upload>
          <Button
            type='primary'
            loading={BGTZLoading}
            onClick={() => {
              setBGTZLoading(true)
              dispatch(
                getSendCatalogChangeNotifyAsync({
                  insuranceCode: form.getFieldValue('insuranceCode'),
                })
              )
                .then(unwrapResult)
                .then((v) => {
                  notification.success({
                    message: '操作成功',
                  })
                  refresh && refresh()
                })
                .finally(() => {
                  setBGTZLoading(false)
                })
            }}
          >
            发送变更通知
          </Button>
          {/* <Upload
            style={{ display: 'none' }}
            ref={Uploadref}
            accept='.xls,.xlsx'
            maxCount={1}
            customRequest={({ file, onSuccess }) => {
              console.log('file', file);
              upload(file, onSuccess)
            }}
            showUploadList={false}
          >
          </Upload>
          {/* <Button type='primary'>下载医疗目录</Button> */}
          {showProgress && (
            <>
              {message}
              {progress ? ': ' + progress : ''}
            </>
          )}
          <Upload
            ref={Uploadref}
            accept='.xls,.xlsx'
            maxCount={1}
            customRequest={({ file, onSuccess }) => {
              console.log('file', file)
              upload(file, onSuccess)
            }}
            showUploadList={false}
          >
            <Button type='primary'>Excel上传目录</Button>
          </Upload>

          <Button
            type='primary'
            onClick={() => {
              const data = {
                insuranceCode: form.getFieldValue('insuranceCode'),
                listType: getListType(code),
              }
              dispatch(syncInsuranceListAsync(data))
                .then(unwrapResult)
                .then((res: any) => {
                  console.log(132165, res)
                  setIdsList(res.map((v: any) => v.id))
                  const item = res.find(
                    (v: any) => v?.taskStatus === 0 || v?.taskStatus === 9
                  )
                  setShowProgress(!!item)
                  setMessage(item?.taskMsg)
                  console.log('item', !!item, item)
                })
            }}
          >
            目录同步
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
